<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @costReport="costReport"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchCostReport="batchCostReport"
        @batchExport="batchExport"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      show-close
      width="1000px"
      visible
      title="添加特殊费用"
      :close-on-click-modal="false"
      :before-close="() => close()"
    >
      <fee-table-edit
        ref="feetableedit"
        @getCode="getCode"
        :disabled="editFormDialogOptions.disabled"
        :params="editFormDialogOptions.val"
        @reload="reload"
        @close="close"
      />

      <span slot="footer">
        <el-button @click="close()">取消</el-button>
        <el-button type="primary" @click="confirm()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import FeeTableEdit from './components/fee-table-edit.vue'

export default {
  components: {
    PageMain,
    PageHeader,
    FeeTableEdit,
  },
  mixins: [BaseTable],
  data() {
    return {
      code: '',
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        val: {},
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .carriageWaybillDetailListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchCostReport() {
      this.$refs.main.getTableCheckedData(true)
    },
    costReport(val) {
      this.editFormDialogOptions.visible = true
      this.editFormDialogOptions.val = val
    },

    close() {
      this.editFormDialogOptions.visible = false
    },
    getCode(code) {
      this.code = code
    },

    confirm() {
      this.$refs.feetableedit
        .save()
        .then(() => {
          this.close()
        })
        .catch(() => {})
    },
    batchExport(data) {
      this.$refs.main.batchExport(data)
    },
  },
}
</script>
